var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMorning = function SvgMorning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9.208.708H7.792v2.125h1.416zm-3.212 2.87L4.493 2.074 3.492 3.076 4.994 4.58zM4.25 6.375H2.125v1.417H4.25zm8.5 0v1.417h2.125V6.375zm.758-3.299-1.001-1.002-1.503 1.504 1.002 1.001zm-7.163 11.09h1.447v2.126h1.416v-2.125h1.447L8.5 12.042zm-.578-6.374h5.466a2.833 2.833 0 1 0-5.466 0m-3.642 2.833h12.75V9.208H2.125z"
  })));
};
export default SvgMorning;